__turbopack_context__.v({
  "body": "chip-module__eaKZhW__body",
  "caret": "chip-module__eaKZhW__caret",
  "chip": "chip-module__eaKZhW__chip",
  "dot": "chip-module__eaKZhW__dot",
  "label": "chip-module__eaKZhW__label",
  "lead": "chip-module__eaKZhW__lead",
  "remove": "chip-module__eaKZhW__remove",
  "trail": "chip-module__eaKZhW__trail",
});
